import { Provider } from "./components/ui/provider";
import { WebRoutes } from "./routes";
import { initAnalytics } from "./core/analytics";
import "./App.css";

initAnalytics();

function App() {
  return (
    <Provider>
      <WebRoutes />
    </Provider>
  );
}

export default App;
